(function () {
  'use strict';

  var STORAGE_KEY = 'foxprint-page-theme';
  var root = document.documentElement;
  var allowedThemes = { light: true, dark: true };

  function getSavedTheme() {
    try {
      var savedTheme = window.localStorage.getItem(STORAGE_KEY);
      return allowedThemes[savedTheme] ? savedTheme : 'light';
    } catch (error) {
      return 'light';
    }
  }

  function saveTheme(theme) {
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // Private browsing and restricted storefront previews may block storage.
    }
  }

  function updateLogo(theme) {
    var logos = document.querySelectorAll('.fp-logo');
    var isDark = theme === 'dark';

    for (var index = 0; index < logos.length; index += 1) {
      var logo = logos[index];
      var logoSrc = logo.getAttribute(isDark ? 'data-dark-logo' : 'data-light-logo');
      var homeLogoSrc = logo.getAttribute(isDark ? 'data-dark-home-logo' : 'data-light-home-logo');

      if (logoSrc) {
        logo.setAttribute('src', logoSrc);
        // app.js changes these values when the homepage header changes state.
        logo.setAttribute('data-src', logoSrc);
      }

      if (homeLogoSrc && logo.hasAttribute('data-src-home')) {
        logo.setAttribute('data-src-home', homeLogoSrc);
      }
    }
  }

  function updateBrowserThemeColor(theme) {
    var themeColor = document.querySelector('meta[name="theme-color"]');

    if (themeColor) {
      themeColor.setAttribute('content', theme === 'dark' ? '#322e2b' : '#F4BD44');
    }
  }

  function updateControl(theme) {
    var control = document.querySelector('[data-theme-toggle]');
    var isDark = theme === 'dark';

    updateLogo(theme);
    updateBrowserThemeColor(theme);

    if (!control) return;

    control.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    control.setAttribute('aria-label', isDark ? 'Switch to light theme' : 'Switch to dark theme');
    control.setAttribute('title', isDark ? 'Switch to light theme' : 'Switch to dark theme');
  }

  function applyTheme(theme, persist) {
    if (!allowedThemes[theme]) return;

    root.setAttribute('data-fp-theme', theme);
    updateControl(theme);
    if (persist) saveTheme(theme);
  }

  // Set the root attribute immediately so dark mode does not flash in light mode.
  applyTheme(getSavedTheme(), false);

  function initThemeControls() {
    var control = document.querySelector('[data-theme-toggle]');
    updateControl(root.getAttribute('data-fp-theme') || 'light');

    if (!control) return;

    control.addEventListener('click', function () {
      var currentTheme = root.getAttribute('data-fp-theme') || 'light';
      applyTheme(currentTheme === 'dark' ? 'light' : 'dark', true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThemeControls);
  } else {
    initThemeControls();
  }
}());
